module.exports = __webpack_public_path__ + "media/images/video/clubpilates-app-promo-4f44365921af433b0235da5c311e1fed.png";